import React from "react";
import Atom from "./Atom";

import "./styles.css"

class Periodic_table extends React.Component {
    callback = (atom) => {
        this.props.callback(atom);
    }

    is_activated_atom = (atom) => {
        //console.log("Atom " + atom);
        let is_active = this.props.is_activate(atom)
        return is_active;
    }

    render() {
        return (
            <div className="PerodicDiv">
                <table className="PerodicTable">
                    {/* Line 1 */}
                    <thead>
                        <tr className="PeriodicLine">
                            <th className="PeriodicElement"><Atom
                                atom="H" atomName="Гідроген" atomMass="1"
                                atomNumber="1" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                            </th>
                            <th className="PeriodicElement">
                            </th>
                            <th className="PeriodicElement">
                            </th>
                            <th className="PeriodicElement">
                            </th>
                            <th className="PeriodicElement">
                            </th>
                            <th className="PeriodicElement">
                            </th>
                            <th className="PeriodicElement">
                            </th>
                            <th className="PeriodicElement"><Atom
                                atom="He" atomName="Гелій" atomMass="4"
                                atomNumber="2" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                            </th>
                            <th className="PeriodicElement">
                            </th>
                            <th className="PeriodicElement">
                            </th>
                            <th className="PeriodicElement">
                            </th>
                        </tr>
                    </thead>


                    {/* Line 2 */}
                    <tr className="PeriodicLine">
                        <td className="PeriodicElement"><Atom
                            atom="Li" atomName="Літій" atomMass="6"
                            atomNumber="3" callback={this.callback}
                            is_active={this.is_activated_atom}
                        />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Be" atomName="Берилій" atomMass="9" atomNumber="4" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="B" atomName="Бор" atomMass="10.8" atomNumber="5" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="C" atomName="Карбон" atomMass="12" atomNumber="6" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="N" atomName="Нітроген" atomMass="14" atomNumber="7" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="O" atomName="Оксиген" atomMass="16" atomNumber="8" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="F" atomName="Фтор" atomMass="19" atomNumber="9" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Ne" atomName="Неон" atomMass="20.2" atomNumber="10" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                        </td>
                        <td className="PeriodicElement">
                        </td>
                        <td className="PeriodicElement">
                        </td>
                    </tr>


                    {/* Line 3 */}
                    <tr className="PeriodicLine">
                        <td className="PeriodicElement"><Atom
                            atom="Na" atomName="Натрій" atomMass="23" atomNumber="11" callback={this.callback}
                            is_active={this.is_activated_atom}
                        />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Mg" atomName="Магній" atomMass="24.3" atomNumber="12" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Al" atomName="Алюміній" atomMass="27" atomNumber="13" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Si" atomName="Силіцій" atomMass="28.1" atomNumber="14" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="P" atomName="Фосфор" atomMass="31" atomNumber="15" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="S" atomName="Сульфур" atomMass="32.1" atomNumber="16" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Cl" atomName="Хлор" atomMass="35.5" atomNumber="17" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement"><Atom
                            atom="Ar" atomName="Аргон" atomMass="40" atomNumber="18" callback={this.callback}
                            is_active={this.is_activated_atom}
                        />
                        </td>
                        <td className="PeriodicElement">
                        </td>
                        <td className="PeriodicElement">
                        </td>
                        <td className="PeriodicElement">
                        </td>
                    </tr>


                    {/* Line 4 */}
                    <tr className="PeriodicLine">
                        <td className="PeriodicElement"><Atom
                            atom="K" atomName="Калій" atomMass="39.1" atomNumber="19" callback={this.callback}
                            is_active={this.is_activated_atom}
                        />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Ca" atomName="Кальцій" atomMass="40.1" atomNumber="20" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Sc" atomName="Скандій" atomMass="45" atomNumber="21" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Ti" atomName="Титан" atomMass="47.9" atomNumber="22" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="V" atomName="Ванадій" atomMass="51" atomNumber="23" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Cr" atomName="Хром" atomMass="52" atomNumber="24" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Mn" atomName="Манган" atomMass="55" atomNumber="25" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                        </td>
                        <td className="PeriodicElement"><Atom
                            atom="Fe" atomName="Ферум" atomMass="56" atomNumber="26" callback={this.callback}
                            is_active={this.is_activated_atom}
                        />
                        </td>
                        <td className="PeriodicElement"><Atom
                            atom="Co" atomName="Кобальт" atomMass="59" atomNumber="27" callback={this.callback}
                            is_active={this.is_activated_atom}
                        />
                        </td>
                        <td className="PeriodicElement"><Atom
                            atom="Ni" atomName="Нікель" atomMass="59" atomNumber="28" callback={this.callback}
                            is_active={this.is_activated_atom}
                        />
                        </td>
                    </tr>


                    {/* Line 5 */}
                    <tr className="PeriodicLine">
                        <td className="PeriodicElement"><Atom
                            atom="Cu" atomName="Мідь" atomMass="63.5" atomNumber="29" callback={this.callback}
                            is_active={this.is_activated_atom}
                        />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Zn" atomName="Цинк" atomMass="65.4" atomNumber="30" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Ga" atomName="Галій" atomMass="69.7" atomNumber="31" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Ge" atomName="Германій" atomMass="72.6" atomNumber="32" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="As" atomName="Арсен" atomMass="74.9" atomNumber="33" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Se" atomName="Селен" atomMass="79" atomNumber="34" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Br" atomName="Бром" atomMass="79.9" atomNumber="35" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Kr" atomName="Криптон" atomMass="83.8" atomNumber="36" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                        </td>
                        <td className="PeriodicElement">
                        </td>
                        <td className="PeriodicElement">
                        </td>
                    </tr>


                    {/* Line 6 !!!!!!!!!!!!!!!!!!!!!!!!!!!*/}
                    <tr className="PeriodicLine">
                        <td className="PeriodicElement"><Atom
                            atom="Rb" atomName="Рубідій" atomMass="85.5" atomNumber="37" callback={this.callback}
                            is_active={this.is_activated_atom}
                        />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Sr" atomName="Стронцій" atomMass="87.6" atomNumber="38" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Y" atomName="Ітрій" atomMass="88.9" atomNumber="39" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Zr" atomName="Цирконій" atomMass="91.2" atomNumber="40" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Nb" atomName="Ніобій" atomMass="92.9" atomNumber="41" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Mo" atomName="Молібден" atomMass="96" atomNumber="42" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Tc" atomName="Технецій" atomMass="98" atomNumber="43" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                        </td>
                        <td className="PeriodicElement"><Atom
                            atom="Ru" atomName="Рутеній" atomMass="101.1" atomNumber="44" callback={this.callback}
                            is_active={this.is_activated_atom}
                        />
                        </td>
                        <td className="PeriodicElement"><Atom
                            atom="Rh" atomName="Родій" atomMass="102.9" atomNumber="45" callback={this.callback}
                            is_active={this.is_activated_atom}
                        />
                        </td>
                        <td className="PeriodicElement"><Atom
                            atom="Pd" atomName="Паладій" atomMass="106.4" atomNumber="46" callback={this.callback}
                            is_active={this.is_activated_atom}
                        />
                        </td>
                    </tr>


                    {/* Line 7 */}
                    <tr className="PeriodicLine">
                        <td className="PeriodicElement"><Atom
                            atom="Ag" atomName="Срібло" atomMass="107.9" atomNumber="47" callback={this.callback}
                            is_active={this.is_activated_atom}
                        />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Cd" atomName="Кадмій" atomMass="112.4" atomNumber="48" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="In" atomName="Індій" atomMass="114.8" atomNumber="49" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Sn" atomName="Олово" atomMass="118.7" atomNumber="50" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Sb" atomName="Стибій" atomMass="121.8" atomNumber="51" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Te" atomName="Телур" atomMass="127.6" atomNumber="52" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="I" atomName="Йод" atomMass="127" atomNumber="53" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement"><Atom
                            atom="Xe" atomName="Ксенон" atomMass="131.3" atomNumber="54" callback={this.callback}
                            is_active={this.is_activated_atom}
                        />
                        </td>
                        <td className="PeriodicElement">
                        </td>
                        <td className="PeriodicElement">
                        </td>
                        <td className="PeriodicElement">
                        </td>
                    </tr>


                    {/* Line 8 */}
                    <tr className="PeriodicLine">
                        <td className="PeriodicElement"><Atom
                            atom="Cs" atomName="Цезій" atomMass="132.9" atomNumber="55" callback={this.callback}
                            is_active={this.is_activated_atom}
                        />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Ba" atomName="Барій" atomMass="137.3" atomNumber="56" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="La" atomName="Лантан" atomMass="138.9" atomNumber="57" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Hf" atomName="Гафній" atomMass="178.5" atomNumber="72" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Ta" atomName="Тантал" atomMass="181" atomNumber="73" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="W" atomName="Вольфрам" atomMass="183.8" atomNumber="74" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Re" atomName="Реній" atomMass="186.2" atomNumber="75" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                        </td>
                        <td className="PeriodicElement"><Atom
                            atom="Os" atomName="Осмій" atomMass="190.2" atomNumber="76" callback={this.callback}
                            is_active={this.is_activated_atom}
                        />
                        </td>
                        <td className="PeriodicElement"><Atom
                            atom="Ir" atomName="Іридій" atomMass="192.2" atomNumber="77" callback={this.callback}
                            is_active={this.is_activated_atom}
                        />
                        </td>
                        <td className="PeriodicElement"><Atom
                            atom="Pt" atomName="Платина" atomMass="195.1" atomNumber="78" callback={this.callback}
                            is_active={this.is_activated_atom}
                        />
                        </td>
                    </tr>


                    {/* Line 9 */}
                    <tr className="PeriodicLine">
                        <td className="PeriodicElement"><Atom
                            atom="Au" atomName="Золото" atomMass="197" atomNumber="79" callback={this.callback}
                            is_active={this.is_activated_atom}
                        />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Hg" atomName="Ртуть" atomMass="200.6" atomNumber="80" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Tl" atomName="Талій" atomMass="204.4" atomNumber="81" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Pb" atomName="Свинець" atomMass="207.2" atomNumber="82" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Bi" atomName="Бісмут" atomMass="209" atomNumber="83" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Po" atomName="Полоній" atomMass="209" atomNumber="84" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="At" atomName="Астат" atomMass="210" atomNumber="85" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Rn" atomName="Радон" atomMass="222" atomNumber="86" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                        </td>
                        <td className="PeriodicElement">
                        </td>
                        <td className="PeriodicElement">
                        </td>
                    </tr>


                    {/* Line 10 */}
                    <tr className="PeriodicLine">
                        <td className="PeriodicElement"><Atom
                            atom="Fr" atomName="Францій" atomMass="223" atomNumber="87" callback={this.callback}
                            is_active={this.is_activated_atom}
                        />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Ra" atomName="Радій" atomMass="226" atomNumber="88" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Ac" atomName="Актиній" atomMass="227" atomNumber="89" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Unq" atomName="Уннілквадій" atomMass="261" atomNumber="104" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Unp" atomName="Уннілпентій" atomMass="262" atomNumber="105" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Unh" atomName="Уннілгексій" atomMass="263" atomNumber="106" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                            <Atom
                                atom="Uns" atomName="Уннілсептій" atomMass="264" atomNumber="107" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="PeriodicElement">
                        </td>
                        <td className="PeriodicElement"><Atom
                            atom="Uno" atomName="Уннілоктій" atomMass="265" atomNumber="108" callback={this.callback}
                            is_active={this.is_activated_atom}
                        />
                        </td>
                        <td className="PeriodicElement"><Atom
                            atom="Une" atomName="Уннілленій" atomMass="266" atomNumber="109" callback={this.callback}
                            is_active={this.is_activated_atom}
                        />
                        </td>
                        <td className="PeriodicElement"><Atom
                            atom="Uun" atomName="Унуннілій" atomMass="272" atomNumber="110" callback={this.callback}
                            is_active={this.is_activated_atom}
                        />
                        </td>
                    </tr>
                </table>

                <table className="AdditionalTable">
                    {/* Additional line 1 */}
                    <tr className="AdditionalLine">
                        <td className="AdditionalElement">
                            <Atom
                                atom="Ce" atomName="Церій" atomMass="140.1"
                                atomNumber="58" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="AdditionalElement">
                            <Atom
                                atom="Pr" atomName="Празеодим" atomMass="140.9"
                                atomNumber="59" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="AdditionalElement">
                            <Atom
                                atom="Nd" atomName="Неодим" atomMass="144.2"
                                atomNumber="60" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="AdditionalElement">
                            <Atom
                                atom="Pm" atomName="Прометій" atomMass="145"
                                atomNumber="61" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="AdditionalElement">
                            <Atom
                                atom="Sm" atomName="Самарій" atomMass="150.4"
                                atomNumber="62" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="AdditionalElement">
                            <Atom
                                atom="Eu" atomName="Європій" atomMass="152"
                                atomNumber="63" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="AdditionalElement">
                            <Atom
                                atom="Gd" atomName="Гадоліній" atomMass="157.3"
                                atomNumber="64" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="AdditionalElement">
                            <Atom
                                atom="Tb" atomName="Тербій" atomMass="158.9"
                                atomNumber="65" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="AdditionalElement">
                            <Atom
                                atom="Dy" atomName="Диспрозій" atomMass="162.5"
                                atomNumber="66" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="AdditionalElement">
                            <Atom
                                atom="Ho" atomName="Гольмій" atomMass="164.9"
                                atomNumber="67" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="AdditionalElement">
                            <Atom
                                atom="Er" atomName="Ербій" atomMass="167.3"
                                atomNumber="68" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="AdditionalElement">
                            <Atom
                                atom="Tm" atomName="Тулій" atomMass="168.9"
                                atomNumber="69" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="AdditionalElement">
                            <Atom
                                atom="Yb" atomName="Ітербій" atomMass="173"
                                atomNumber="70" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="AdditionalElement">
                            <Atom
                                atom="Lu" atomName="Лютенцій" atomMass="175"
                                atomNumber="71" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                    </tr>

                    {/* Additional line 2 */}
                    <tr className="AdditionalLine">
                        <td className="AdditionalElement">
                            <Atom
                                atom="Th" atomName="Торій" atomMass="232"
                                atomNumber="90" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="AdditionalElement">
                            <Atom
                                atom="Pa" atomName="Протактиній" atomMass="231"
                                atomNumber="91" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="AdditionalElement">
                            <Atom
                                atom="U" atomName="Уран" atomMass="238"
                                atomNumber="92" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="AdditionalElement">
                            <Atom
                                atom="Np" atomName="Нептуній" atomMass="237"
                                atomNumber="93" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="AdditionalElement">
                            <Atom
                                atom="Pu" atomName="Плутоній" atomMass="244"
                                atomNumber="94" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="AdditionalElement">
                            <Atom
                                atom="Am" atomName="Америцій" atomMass="243"
                                atomNumber="95" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="AdditionalElement">
                            <Atom
                                atom="Cm" atomName="Кюрій" atomMass="247"
                                atomNumber="96" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="AdditionalElement">
                            <Atom
                                atom="Bk" atomName="Берклій" atomMass="247"
                                atomNumber="97" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="AdditionalElement">
                            <Atom
                                atom="Cf" atomName="Каліфорній" atomMass="251"
                                atomNumber="98" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="AdditionalElement">
                            <Atom
                                atom="Es" atomName="Ейнштейній" atomMass="254"
                                atomNumber="99" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="AdditionalElement">
                            <Atom
                                atom="Fm" atomName="Фермій" atomMass="257"
                                atomNumber="100" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="AdditionalElement">
                            <Atom
                                atom="Md" atomName="Менделєвій" atomMass="258"
                                atomNumber="101" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="AdditionalElement">
                            <Atom
                                atom="No" atomName="Нобелій" atomMass="259"
                                atomNumber="102" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                        <td className="AdditionalElement">
                            <Atom
                                atom="Lr" atomName="Лоуренцій" atomMass="260"
                                atomNumber="103" callback={this.callback}
                                is_active={this.is_activated_atom}
                            />
                        </td>
                    </tr>
                </table>
            </div>
        )
    }
}

export default Periodic_table